import React from "react";
import { Navigate } from "react-router-dom";

export const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("admin_token");

  // If token is missing, redirect to login
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};
